import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  BackgroundMediaUploadJob,
  BackgroundMediaUploadService,
} from 'src/app/services/shared/background-media-upload.service';

@Component({
  standalone: true,
  selector: 'app-header-upload-progress',
  imports: [CommonModule],
  templateUrl: './header-upload-progress.component.html',
  styleUrls: ['./header-upload-progress.component.scss'],
})
export class HeaderUploadProgressComponent implements OnInit, OnDestroy {
  jobs: BackgroundMediaUploadJob[] = [];
  panelOpen = false;
  private sub?: Subscription;

  constructor(private readonly uploadService: BackgroundMediaUploadService) {}

  get visible(): boolean {
    return this.jobs.length > 0;
  }

  get primaryJob(): BackgroundMediaUploadJob | null {
    const active = this.jobs.find((j) => j.status === 'uploading' || j.status === 'finalizing');
    return active ?? this.jobs[0] ?? null;
  }

  get ringProgress(): number {
    const job = this.primaryJob;
    if (!job) {
      return 0;
    }
    if (job.status === 'finalizing') {
      return 100;
    }
    return Math.min(100, Math.max(0, job.value));
  }

  ngOnInit(): void {
    this.sub = this.uploadService.jobs$.subscribe((jobs) => {
      this.jobs = jobs;
      if (!this.visible) {
        this.panelOpen = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  togglePanel(event: Event): void {
    event.stopPropagation();
    if (!this.visible) {
      return;
    }
    this.panelOpen = !this.panelOpen;
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.panelOpen = false;
  }

  truncateName(name: string, max = 36): string {
    if (!name || name.length <= max) {
      return name || '';
    }
    return `${name.slice(0, max - 3)}...`;
  }
}
